<template>
  <div class="mb-3">
    <input hidden :name="field_name" :value="selectedCopy" class="form-control" />
    <div class="position-relative">
      <div v-if="selectedImage">
        <div class="position-absolute btn btn-sm btn-danger mt-3" @click="selectedCopy = null" style="right: 15px"><i
            class="fas fa-times"></i></div>
        <img class="img-fluid" alt="background" :src="selectedCopy" />
      </div>
      <div v-else class="d-flex justify-content-center align-items-center bg-light" style="padding: 28% 1px">
        {{ $t("js.backend.image_selector.select_image") }}
      </div>
    </div>
    <div class="d-flex overflow-auto">
      <a v-for="image in images" class="overflow-hidden" style="min-width: 180px;max-height:100px;"
        @click.prevent="setSelected(image)" href="#">
        <img style="width:180px" alt="background" :src="image" />
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "@/types";

export default defineComponent({
  name: "ImageSelector",
  props: {
    images: {
      type: Array as PropType<string[]>,
      required: true,
    },
    selected: {
      type: String,
      default: null,
    },
    field_name: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      selectedCopy: this.selected,
    }
  },
  computed: {
    selectedImage() {
      if (this.selectedCopy === null) return null;
      return this.images.find((i: string) => i === this.selectedCopy);
    },
  },
  methods: {
    setSelected(image: string) {
      this.selectedCopy = image;
    },
  },
});
</script>
